import { Box, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory, useLocation } from 'react-router-dom';
import EditSaveActions from 'Shared/Button/EditSaveActions';
import ButtonApp from 'Shared/Button';
import AddIcon from '@mui/icons-material/Add';
import { TypeDocShip } from 'Components/ControleOrders/Orders/constants';
import HeaderItem from 'Components/Import/AchatDocuments/Detail/HeaderItem';
import useForm from 'Shared/Hooks/useForm';
import EditHeader from 'Components/Import/AchatDocuments/Detail/EditHeader';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import EnhancedTable from 'Shared/EnhancedTable';
import ConfirmRemoveDialog from 'Shared/ConfirmDialog/ConfirmRemoveDialog';
import SaveIcon from '@mui/icons-material/Save';
import { roundPrice } from 'Utils/ulilities';
import {
  columns, Fields, INIT_DOC,
  validateBodyDocVente,
  validateProducts,
} from './constants';
import { saveDocumentVente } from '../PaymentServices';
import DocumentVenteProduct from './DocumentVenteProduct';
import useOpsEnumLibreCial from './useOpsEnumLibreCial';

const DocumentVente = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [openConfirm, setOpenConfirm] = useState({ productRef: null, open: false });
  const [document, setDocument] = useState({ ...INIT_DOC, type: state?.docType, ...state?.doc });
  const { values: documentEdit, onChange, reset } = useForm({
    ...INIT_DOC, type: state?.docType, ...state?.doc,
  });
  const { values: editProduct, onChange: onChangeLine } = useForm(
    { open: false, target: { isNewLine: true } },
  );
  const { enumLibreCials } = useOpsEnumLibreCial();

  const onOpenAttachProduct = (e, nextProduct = { isNewLine: true }) => {
    onChangeLine({ target: { name: 'open', value: nextProduct.isNewLine ? !editProduct.open : true } });
    onChangeLine({ target: { name: 'target', value: nextProduct } });
  };

  const onHandleEdit = () => {
    setIsEdit(!isEdit);
    reset(document);
  };
  const onChangeDocument = (event) => {
    onChange(event);
    if (event.target.name === 'souche') {
      onChange({ target: { name: 'reference', value: Date.now() } });
    }
  };
  const onSaveDocInfo = () => {
    setIsEdit(!isEdit);
    setDocument(documentEdit);
  };
  const onSaveDoc = async () => {
    // todo check data :!!!!!!
    const docProducts = document.products.map((p) => ({
      productRef: p.product.reference,
      productName: p.productName,
      amountTtc: p.amountTtc,
      quantity: p.quantity,
      remise: p.remise,
      price: p.price,
    }));

    if (docProducts.length === 0) {
      toast.error('Ajouter au moins un produit');
      return;
    }
    if (!validateProducts(docProducts)) {
      toast.error('Vérifier que tous les produits sont valides');
      return;
    }
    const bodyDocVente = {
      colisage: documentEdit.colisage,
      // Send a date-only string to avoid timezone-related day shifts (J-1)
      dateStr: documentEdit.date ? format(new Date(documentEdit.date), 'yyyy-MM-dd') : null,
      reference: documentEdit.reference,
      totalWeight: documentEdit.totalWeight,
      type: documentEdit.type,
      numExpedition: documentEdit.numExpedition,
      biller: documentEdit.biller?.userName,
      clientId: documentEdit.client?.id,
      // controlledById: documentEdit.controlledBy?.id,
      expedition: documentEdit.expedition?.code,
      packedBy: documentEdit.packedBy?.userName,
      paymentMode: documentEdit.paymentMode?.code,
      picker: documentEdit.picker?.userName,
      commercialId: documentEdit.saler?.id,
      repoId: documentEdit.repo?.id,
      souche: documentEdit.souche?.id,
      products: docProducts,
      sageId: documentEdit.sageId,
    };
    try {
      validateBodyDocVente(bodyDocVente);
    } catch (error) {
      toast.error(error.message);
      return;
    }
    try {
      setLoading(true);
      await saveDocumentVente(bodyDocVente);
      // setDocument(documentEdit);
      toast.success('Modifications bien enregistrer!');
      // go back
      history.goBack();
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  const onChangeProducts = (products) => {
    setDocument({ ...document, products });
  };
  const onSelectProductForRemove = (productRef) => {
    setOpenConfirm({ open: true, productRef });
  };
  const onDeleteProduct = () => {
    const products = document.products
      .filter((p) => p.product.reference !== openConfirm.productRef);
    setDocument({ ...document, products });
    toast.success('Produit supprimé avec succès');
    setOpenConfirm({ open: false });
  };
  const total = document.products.reduce((prev, pro) => prev + pro.amountTtc, 0);
  return (
    <Box>
      {loading && <GlobalLoader />}
      {openConfirm.open && (
      <ConfirmRemoveDialog
        title="Suppresion"
        content="Êtes-vous sûr de vouloir supprimer ce produit ?"
        handleClose={() => setOpenConfirm({ open: false })}
        handleClick={onDeleteProduct}
      />
      )}
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <IconButton onClick={history.goBack}>
            <ArrowBackIcon style={{ color: 'black' }} />
          </IconButton>
          <TypeDocShip type={document.type} />
          <Typography sx={{ font: 'normal 600 28px Montserrat', marginRight: 1 }}>
            {document.souche ? `${document.souche.name} - ${document.reference}` : 'Document de vente'}
          </Typography>
          <EditSaveActions
            isEdit={isEdit}
            onHandleClose={() => setIsEdit(!isEdit)}
            onHandleEdit={onHandleEdit}
            onHandleSave={onSaveDocInfo}
          />
          <ButtonApp
            label="Ajouter Une Référence"
            onClick={onOpenAttachProduct}
            startIcon={<AddIcon />}
            style={{
              minHeight: 33,
              marginLeft: 'auto',
            }}
          />
        </Box>
        <Typography sx={{ font: 'normal 600 16px Montserrat', color: '#38485C' }}>
          {`${document?.client?.code || ''} ${document?.client?.name || ''} - `}
          {document.date && format(new Date(document.date), 'dd/MM/yyy')}
        </Typography>
      </Box>
      <Box sx={{
        background: '#FFFFFF',
        boxShadow: '0px 12px 26px #0000000D',
        borderRadius: 1.4,
        mt: 3,
        mb: 3,
        p: 3,
      }}
      >
        {isEdit
          ? (
            <EditHeader
              document={documentEdit}
              onChange={onChangeDocument}
              fileds={Fields.map((f) => (documentEdit.sageId && f.name === 'souche' ? ({ ...f, disabled: true }) : f))}
              enumLibreCials={enumLibreCials}
            />
          ) : (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* <HeaderItem title="RÉFÉRENCE" subTitle={document?.reference} /> */}
                <HeaderItem title="REPRÉSENTANT" subTitle={document.saler?.name} />
                <HeaderItem title="EXPÉDITION" subTitle={document.expedition?.name} />
                <HeaderItem title="NUMÉRO D’EXPÉDITION" subTitle={document.numExpedition} />
                <HeaderItem title="CONDITIONS DE LIVRAISON" subTitle={document.paymentMode?.name} />
                <HeaderItem title="NOMBRE DE COLIS" subTitle={document.colisage} />
              </Box>
              <Box sx={{
                display: 'flex', justifyContent: 'space-between', mt: 2,
              }}
              >
                <HeaderItem title="DÉPÔT" subTitle={document.repo?.name} />
                <HeaderItem title="POIDS" subTitle={document.totalWeight} />
                {/* <HeaderItem
                 title="CONTRÔLÉ PAR"
                 subTitle={formatUserName(document.controlledBy)} /> */}
                <HeaderItem
                  title="FACTURÉ PAR"
                  subTitle={document.biller?.userName}
                />
                <HeaderItem title="PIQUÉ PAR" subTitle={document.picker?.userName} />
                <HeaderItem title="EMBALLÉ PAR" subTitle={document.packedBy?.userName} />
              </Box>
            </>
          )}
      </Box>

      {editProduct.open
        ? (
          <DocumentVenteProduct
            documentProducts={document.products}
            onChange={onChangeLine}
            onClose={onOpenAttachProduct}
            saveProduct={onChangeProducts}
            onEditLine={onOpenAttachProduct}
            onRemoveLine={onSelectProductForRemove}
            productLine={editProduct.target}
          />
        ) : null }

      <EnhancedTable
        staticData
        rows={document.products}
        headCells={columns(onOpenAttachProduct, onSelectProductForRemove)}
        count={document.products.length}
        rowsPerPageOptions={[10, 15, 20]}
      />
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Typography sx={{ mr: 'auto', color: '#707070', fontWeight: 500 }}>
          MONTANT TOTAL GLOBAL :
          <span style={{ color: '#007BC6' }}>{`${roundPrice(total)} DH`}</span>
        </Typography>
        <ButtonApp
          onClick={history.goBack}
          style={{
            marginRight: 15, height: 40, background: '#FFF', color: 'black', boxShadow: 'none',
          }}
          label="Annuler"
        />
        <ButtonApp style={{ height: 40 }} endIcon={<SaveIcon />} onClick={onSaveDoc} label="Enregister" />
      </Box>
    </Box>
  );
};

export default DocumentVente;
